import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { PaginationInstance } from 'ngx-pagination';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { UserRole } from '../../customerservice/constants/user-role.constants';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { DataShareService } from '../../shared/services/data.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { Constants, DefaultTicketType } from '../common/constants';
import { SearchRequestConstants } from '../common/search-request-constants';
import { ComposeEmailTicketConstants } from '../constants/compose-email.constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { Status } from '../enums/ticket-status.enum';
import { TicketType } from '../enums/ticket-type.enum';
import { SearchModel } from '../interface/ticketingsystem/search.model';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { WorkTicket } from '../interface/ticketingsystem/work-ticket';
import { DeleteModal } from '../models/delete-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from './../services/department.service';
@Component({
    selector: 'my-tickets',
    templateUrl: '../templates/template1/views/my-tickets.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/ticket.less', '../templates/template1/themes/default/css/my-tickets.component.less'
    ]
})
export class MyTicketsComponent implements OnInit {

    @ViewChild('ticketType') ticketType: ElementRef;

    myTicketsForm: FormGroup;
    rightContentWidth = 1000;
    active = true;
    id: any;
    tabTitle: string;
    componentName: any;
    tabModel: ViewTabModel;
    tabs: any[] = new Array<ViewTabModel>();
    existedValues: ViewTabModel[] = new Array<ViewTabModel>();
    deleteModal: DeleteModal;
    justifyingTabs = false;
    allfieldsDisable: boolean;
    ticketTypes: any[];
    departments: any[];
    userInfo: UserInfo;
    myTickets: any[] = new Array<WorkTicket>();
    allTickets: any[] = new Array<WorkTicket>();
    users: any[];
    disputeReason: any[];
    isClearClicked = false;
    showAllTickets = false;
    createdByOnSelectAll = true;
    ticketSearchModel: any;
    isSearch: boolean;     // API request model
    searchStr: string;

    pageNumber = 1;
    pageSize = 25;
    pageCount = 0;
    isDesc = true;
    pageSizes: number[] = [10, 25, 50, 75];

    sortColumn: any = 'TICKET_NUMBER';
    sort = 'DESC';

    isTicketView: boolean;
    @Input() isDiputeTicketSearch: boolean;
    disputeSearch = false;
    overDueCount: number;
    ticketTypeOnSelectAll = true;
    departmentOnSelectAll = true;
    sourceOnSelectAll = true;
    statusOnSelectAll = true;
    subTypeOnSelectAll = true;
    priorityOnSelectAll = true;
    disputeReasonOnSelectAll = true;
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    countryId: number;
    fieldTypes: SearchRequestConstants;
    @Input() operatingCountries: any;
    @Input() statusTypes: any;
    @Input() sourceTypes: any;
    @Input() ticketPriorities: any;

    /**
     * Pagination instance - to avoid console warnings - inorder to assign id for pagination
     */
    public paginationInstance: PaginationInstance = {
        id: 'my-tickets-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };

    public dropdownSettings: any = {
        sourceDropdownList: [],
        sourceSelectedItems: [],
        sourceIndex: 1,
        typeDropdownList: [],
        typeSelectedItems: [],
        typeIndex: 2,
        subTypeDropdownList: [],
        subTypeSelectedItems: [],
        subTypeIndex: 3,
        statusDropdownList: [],
        statusSelectedItems: [],
        statusIndex: 4,
        priorityDropdownList: [],
        prioritySelectedItems: [],
        priorityIndex: 5,
        departmentDropdownList: [],
        departmentSelectedItems: [],
        departmentIndex: 6,
        createdByDropdownList: [],
        createdBySelectedItems: [],
        createdByIndex: 7,
        disputeReasonDropdownList: [],
        disputeReasonSelectedItem : [],
        disputeReasonIndex:8,
        settings: {},
    };

    constructor(private _cacheService: CacheService, private _formbulider: FormBuilder, private _dataShareService: DataShareService,
         private _commonService: CommonService,
        private _customerservice: CustomerService,
        private departmentService: DepartmentService,
        private _translatePipe: TranslateService,
        private messageService: MessageService, private  chRef:  ChangeDetectorRef) {

    }
    ngOnInit(): void {
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.tabModel = new ViewTabModel();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_TICKETS_VIEW + ']'), AccessLevel.Customer_Service);
        this.active = false;
        this.activetab = 1;
        this.countryId = this.getAllowedCountries();
        this.buildForm();
        this.getOperatingCountries();
        this.fieldTypes = new SearchRequestConstants();
        this.ticketSearchModel = new SearchModel;
        this.getTicketStatus();
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketPriorities();
        this.subTypesSort();
        this.ticketTypesSort();
        // this.getDisputeReasons();
        this.allfieldsDisable = false;
        this._translatePipe.get('Country is required for selected CMS Group');
      
        this._dataShareService.customerServiceMessage.subscribe(message => {
            if (message && message !== '') {
                const splittedMessage = message.split('-');
                this.rightContentWidth = parseInt(splittedMessage[0]);

            }
        });
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
        this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.isDiputeTicketSearch ? this.disputeSearch = true : '';
    }
    intializeMultiselectDropdowns() {

        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.statusDropdownList = [];
        this.dropdownSettings.statusSelectedItems = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.priorityDropdownList = [];
        this.dropdownSettings.prioritySelectedItems = [];
        this.dropdownSettings.createdByDropdownList=[];
        this.dropdownSettings.createdBySelectedItems=[];
        this.dropdownSettings.disputeReasonDropdownList=[];
        this.dropdownSettings.disputeReasonSelectedItem=[];
        this.dropdownSettings.settings = {
            text: 'Select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            classes: 'myclass custom-class',
            badgeShowLimit: 1,
            disabled: false
        };
    }
    activetab: number;
    selectTab(tab: any) {
        this.activetab = tab;
    }
    changeTab(tab: any) {
        this.activetab = tab;
    }
    doNotRemoveFormData() {
        //data should not be removed...
    }
    subscribeTabContent() {
        this.messageService.getCustomerServiceTabContent().subscribe((data: any) => {
            if (data) {
                this.id = data.id;
                this.tabTitle = data.tabName;
                this.componentName = data.componentName;
                this.addNewTab();
                this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                this.messageService.setOpenTabsInfo((this.tabs && this.tabs.length) ? true : false);
            }
        });
    }

    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
  */
    subscribeClosedTabs() {
        this.messageService.getCloseTabsEvent().subscribe((data: any) => {
            if (data) {
                this.closeAllOpenedTabs();
            }
        });
    }
    addNewTab(): void {
        this.tabModel = new ViewTabModel();
        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.componentName = this.componentName;
        this.existedValues = new Array<ViewTabModel>();
        const index = this.tabs.map(function (el) {
            return el.id;
        }).indexOf(this.id);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            // need to display information -- as you reached maxiumum number of tabs.
            this.displayAlertBoxOnReachingMaxTabs();
        } else {
            if (index < 0) {
                this.tabs.push(this.tabModel);
            } else {
                const selectedId = this.id;
                this.tabs.forEach(function (x: ViewTabModel) {
                    if (x.id !== selectedId) {
                        x.active = false;
                    } else {
                        x.active = true;
                    }
                });
            }
        }
    }

        /*
    form data to download to pdf/ csv/print
    */
   Download() {
    let rowdata = new Array<any>();
    const finalrows = new Array<any>();
    const columns = [
        this._translatePipe.get('ticketing-system.Priority')['value'],
        this._translatePipe.get('ticketing-system.Ticket#')['value'],
        this._translatePipe.get('ticketing-system.Subject')['value'],
        this._translatePipe.get('ticketing-system.Ticket Subtype')['value'],
        this._translatePipe.get('ticketing-system.Dispute Reason')['value'],
        this._translatePipe.get('ticketing-system.Status')['value'],
        this._translatePipe.get('ticketing-system.Due Date')['value'],
        this._translatePipe.get('ticketing-system.Created Date')['value'],
        this._translatePipe.get('ticketing-system.Created By')['value'],
        this._translatePipe.get('ticketing-system.Last Modified Date')['value']];

       this._customerservice.SearchTicketsOnPagination(null, [this.userInfo.userId], this.myTicketsForm.value.ticketNumber,
        (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.statusSelectedItems.map((item: any) => item.id)),
        (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
        this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.myTicketsForm.value.overDueCount, null,
        this.myTicketsForm.get('email').value ? this.myTicketsForm.get('email').value :null,
        this.myTicketsForm.get('email').value?this.myTicketsForm.get('operatingCountryId').value:null,
        (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map((item: any) => item.id) : []),
        (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map((item: any) => item.id) : []),true
       ).subscribe((response)=>{
        if (response && response['content']) {
            const tickets=response['content'];
            for (let i = 0; i < tickets.length; i++) {
                rowdata = [];
                const a1 = tickets[i];
                rowdata.push(a1.priorityValue);
                rowdata.push('\t' + a1.ticketNumber);
                rowdata.push(a1.subject);
                rowdata.push(a1.subType);
                rowdata.push(a1.disputeReasonName ? a1.disputeReasonName : '');
                rowdata.push(a1.status);
                rowdata.push(a1.dueDate ? moment.utc(a1.dueDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                rowdata.push(a1.createdDate ? moment.utc(a1.createdDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                rowdata.push(a1.createdByName ? a1.createdByName : '');
                rowdata.push(a1.modifiedDate ? moment.utc(a1.modifiedDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                finalrows.push(rowdata);
            }
          
        }
        const title =  this._translatePipe.get('ticketing-system.My Tickets')['value'];
       this._customerservice.ExcelDownload(columns, finalrows, 'My Tickets', title,);   
    
       })

      
}
    /**
     * removes tab at specific index
     * @param tab
     */
    removeTabHandler(tab: any): void {
        if (this.tabs) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        }
    }

    /**
     * Close all opened tabs
     */
    closeAllOpenedTabs() {
        this.tabs = []; //new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
    }

    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    displayAlertBoxOnReachingMaxTabs() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    }
    openDropDown(element: string) {
        const elem = document.getElementById(element);
        const dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute('hidden');
    }
    onDropDowneBlur(element: string) {
        const elem = document.getElementById(element);
        const dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute('hidden', 'true');
    }
    getAssignedUsersByDepartments(departmentIds: number[], onLoad?: Boolean) {
        if (departmentIds) {
            this.dropdownSettings.createdByDropdownList=[];
            this.dropdownSettings.createdBySelectedItems=[];
            this._customerservice.getAssignedUsersByDepartmentIds(departmentIds).subscribe(response => {
            if (response) {
                this.users = response;
                
                 this.users.forEach(item => {
                    this.dropdownSettings.createdByDropdownList.push({ id: item.id, itemName: item.name.trim() });
                });

                if(this.dropdownSettings != null) 
                {
                    if(this.dropdownSettings.createdByDropdownList !=null && !this.dropdownSettings.createdByDropdownList.find(user => user.id === 1)) 
                    {
                        this.dropdownSettings.createdByDropdownList.push({ id: 1, itemName: UserRole.SuperAdministrator }); 
                    }
                }
                this.dropdownSettings.createdByDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                if (onLoad) {
                 this.dropdownSettings.createdBySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.createdByDropdownList));
                 this.onSearch();
                }
                if (this.isClearClicked) {
                    this.onSearch();
                    this.isClearClicked = false;
                }
            } else {
                 this.users = [];
                 this.dropdownSettings.createdByDropdownList=[];
                 this.dropdownSettings.createdBySelectedItems=[];
            }
        });
        }
    }
    buildForm(): void {
        this.myTicketsForm = this._formbulider.group(
            {
                ticketNumber: [''],
                operatingCountryId: [this.countryId],
                type: [''],
                subType: [''],
                disputeReason:[''],
                source: [''],
                department: [''],
                status: [''],
                priority: [''],
                showAllTickets: [false],
                overDueCount: [false],
                email:['',[Validators.pattern(ComposeEmailTicketConstants.EMAIL_REGEXP)]],
                createdBy:[]
            });
    }

    ShowTicketAndDepatrmentBycountry(countryId) {
        this.countryId = countryId;
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.sourceTypes = [];
        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.departments = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.createdByDropdownList = [];
        this.dropdownSettings.createdBySelectedItems = [];
        this.disputeReason = [];
        this.dropdownSettings.disputeReasonDropdownList=[];
        this.dropdownSettings.disputeReasonSelectedItem=[];
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        // this.getDisputeReasons();

    }
    
    getEditPermission(departmentId: number) {
        if (departmentId) {
            const isView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_DEPARTMENT_TICKETS_EDIT + ']'), AccessLevel.Department, departmentId);
            return isView;
        } else {
            return false;
        }
    }
    /**
   * display alert box if the logged in user do not have permission to see the fbo/retail information
   */
    displayAlertbox() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    }

    getDepartments() {
            this._customerservice.getAllDepartmentsByOperatingCountryId(this.countryId).subscribe((response) => {
                if (response) {
                    this.departments = response;
                    if (this.departments) {
                        this.departments.sort(function (item1, item2) {
                            const dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase();
                            if (dept1 < dept2) { //sort string ascending
                                return -1;
                            }
                            if (dept1 > dept2) {
                                return 1;
                            }
                            return 0;
                        });
                        if (!this.userInfo.hasSystemRole) {
                            if (this.userInfo.privileges.departments && this.userInfo.privileges.departments.length > 0) {
                                const departmentIds = this.userInfo.privileges.departments.map(function (a: any) { return a.id; });
                                this.departments = this.departments.filter(function (item) {
                                    return departmentIds.indexOf(item.id) != -1;
                                });
                            }
                        }
                        this.departments.forEach(item => {
                            this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value });
                        });
                        this.dropdownSettings.departmentSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.departmentDropdownList));
                        if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                            this.getAssignedUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id), true);
                        }
                        //this.onSearch();
                    }
                }
            });

    }
               subTypesSort() {
            this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                if (tickettype1 < tickettype2) { //sort string ascending
                    return -1;
                }
                if (tickettype1 > tickettype2) {
                    return 1;
                }
                return 0;
            });
         }
         ticketTypesSort() {
            this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                if (tickettype1 < tickettype2) { //sort string ascending
                    return -1;
                }
                if (tickettype1 > tickettype2) {
                    return 1;
                }
                return 0;
            });
         }

    getTicketTypesAndSubTypes() {
        this.departmentService.getTicketTypesAndSubTypes(this.countryId).subscribe(response => {
            if (response && !this.isDiputeTicketSearch) {
                this.ticketTypes = response;
                if (this.ticketTypes.length == 0) {
                    this.dropdownSettings.typeDropdownList = [];
					this.dropdownSettings.subTypeDropdownList = [];
					this.dropdownSettings.subTypeSelectedItems = [];
					this.dropdownSettings.typeSelectedItems = [];
                } else if (this.ticketTypes.length > 0) {

                this.ticketTypes.forEach(item => {
                    let operatingCountryName: string;
                    if (item.operatingCountryName !== null) {
                        operatingCountryName = item.operatingCountryName.trim();
                    } else if (item.operatingCountryName === null && (item.value == DefaultTicketType.Orders || item.value == DefaultTicketType.Products)) {
                        operatingCountryName = 'ALL';
                    }
                     const ticketType = operatingCountryName + ' ' + '-' + ' ' + item.value.trim();
                    this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: ticketType });
                    if (ticketType.includes('FLP360')) {
                        item.subTypes.forEach((subType: any) => {
                            const subTypeName =  subType.name.trim() + '(' + item.value.trim() + ')';
                            this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        });
                    } else {
                        item.subTypes.forEach((subType: any) => {
                             this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                        });
                    }
                    this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.subTypeDropdownList));
                    if (item.value === TicketType.Order) {
                       this.getDisputeReasons();
                    } 
                });
                this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
               this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
               // this.getDisputeReasons();
            } else if (response && this.isDiputeTicketSearch) {
                this.ticketTypes = response.filter((type: any) => type.value === TicketType.Order);
                this.ticketTypes.forEach(item => {
                    this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: item.value.trim() });
                    this.dropdownSettings.typeSelectedItems.push({ id: item.id, itemName: item.value.trim() });
                });
               
                const selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id);
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {
                    if (type.value.includes('FLP360')) {
                        this.subTypesSort();
                    type.subTypes.forEach((subType: any) => {
                        const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subTypeName });
                    });
                    } else {
                        this.subTypesSort();
                    type.subTypes.forEach((subType: any) => {
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                        this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subType.name.trim() });
                    });
                    }

                });
                this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.typeDropdownList));
               // this.getDisputeReasons();
            }
                }
        });
    }
    /**
     * @description to Search Tickets
     * @date 2020-01-31
     * @param {boolean} [tabChange]
     * @memberof MyTicketsComponent
     */
    onSearch(tabChange?: boolean): void {
        const searchBtn = document.getElementById('search-button');
        if (searchBtn) {
            searchBtn.classList.add('button-active');
            setTimeout(() => {
                searchBtn.classList.remove('button-active');
            }, 1000);
        }
        if (!tabChange) {
            this.pageNumber = 1;
        } else {
            this.pageNumber = isNaN(this.pageNumber) ? 1 : this.pageNumber;
        }
        this.getTicketsSearch();
    }

    searchWithTicketNumber() {
        if (this.ticketSearchModel.ticketNumber || this.myTicketsForm.get('email').value) {
            this.dropdownSettings.settings = {...this.dropdownSettings.settings, disabled: true};
            this.chRef.detectChanges();
            this.myTicketsForm.controls['overDueCount'].disable();
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
            this.OnTabSearchFocus();
        } else {
            this.dropdownSettings.settings = {...this.dropdownSettings.settings, disabled: false};
            this.chRef.detectChanges();
            this.myTicketsForm.controls['overDueCount'].enable();
        }
    }

    getSourceTypes() {
        if (this.sourceTypes) {
            this.getDepartments();
                this.sourceTypes.forEach(item => {
                this.dropdownSettings.sourceDropdownList.push({ id: item.id, itemName: item.value });
            });
             this.dropdownSettings.sourceSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.sourceDropdownList));
        } else {
            this.sourceTypes = [];
            this.departments = [];
            this.dropdownSettings.departmentDropdownList = [];
            this.dropdownSettings.departmentSelectedItems = [];
        }
    }

    getTicketPriorities() {
        if (this.ticketPriorities) {
            this.ticketPriorities.forEach(item => {
                this.dropdownSettings.priorityDropdownList.push({ id: item.id, itemName: item.value.trim() });
            });
            this.dropdownSettings.prioritySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.priorityDropdownList));
        }
    }

    getTicketStatus() {
        if (this.statusTypes) {
            this.dropdownSettings.statusSelectedItems = [];
            this.statusTypes.forEach(item => {
                this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
                if (item.id === Status.InProgress || item.id === Status.New
                    || item.id === Status.OnHold) {
                    this.dropdownSettings.statusSelectedItems.push({ id: item.id, itemName: item.value });
                }
                this.statusOnSelectAll = false;
            });
        }
    }

    showAllTicketsCheckBox(event: any) {
        this.dropdownSettings.statusSelectedItems = [];
        if (event.target.checked) {
            this.showAllTickets = true;
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
        } else {
            this.showAllTickets = false;
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList.filter((item: any) => item.id === Status.InProgress);

        }
    }

    /**
     * sort table by respective column
     * @param sortColumn
     */
    sortTableByColumn(sortColumn: string) {
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? 'DESC' : 'ASC';
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.myTickets.length === 0) {
            return;
        }
        this.getTicketsSearch();
    }
    /**
       * On Page change
       * @param pageNumber
       */
    pageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.getTicketsSearch();
        }
    }

    myTicketsSearchFormSubmit() {
        this.pageNumber = 1;
        this.getTicketsSearch();
    }
    getOverDueCount() {
        this._customerservice.getOverDueCount(null, [this.userInfo.userId], this.myTicketsForm.value.ticketNumber,
            (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 ? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
            (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 ? this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id) : []),
            ([Status.InProgress]),
            (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
             this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, true,
             ).subscribe((response: WorkTicket[]) => {
                if (response) {
                    this.overDueCount = response['totalCount'];
                }
            });
    }
    getTicketsSearch() {
if(this.myTicketsForm.valid && !(this.myTicketsForm.get('ticketNumber').value && this.myTicketsForm.get('email').value )){ 
        if (!(this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length > 0)) {
            this.dropdownSettings.statusSelectedItems.push({ id: Status.InProgress, itemName: Status[Status.InProgress] });
            this.statusOnSelectAll = false;
        }
        this._customerservice.SearchTicketsOnPagination(null, [this.userInfo.userId], this.myTicketsForm.value.ticketNumber,
                (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.typeSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.subTypeSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.sourceSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.myTicketsForm.value.ticketNumber || this.myTicketsForm.value.email) ? this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.statusSelectedItems.map((item: any) => item.id)),
                (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map((item: any) => item.id) : []),
                this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.myTicketsForm.value.overDueCount, null,
                this.myTicketsForm.get('email').value ? this.myTicketsForm.get('email').value :null,
                this.myTicketsForm.get('email').value?this.myTicketsForm.get('operatingCountryId').value:null,
                (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map((item: any) => item.id) : []),
                (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map((item: any) => item.id) : [])
                ,false).subscribe((response: WorkTicket[]) => {
                    if (response) {
                        this.pageCount = response['totalCount'];
                        this.allTickets = response['content'];
                        this.myTickets = response['content'];
                        if (this.allTickets && this.allTickets.length) {
                            this.allTickets.forEach(x => {
                                if (x.dueDate) {
                                    x.dueDate = moment.utc(x.dueDate)
                                        .utcOffset(0).format('DD-MMM-YYYY');
                                }
                                if (x.createdDate) {
                                    x.createdDate = moment.utc(x.createdDate)
                                        .utcOffset(0).format('DD-MMM-YYYY');
                                }
                                if (x.modifiedDate) {
                                    x.modifiedDate = moment.utc(x.modifiedDate)
                                        .utcOffset(0).format('DD-MMM-YYYY');
                                }
                            });
                        }
                    } else {
                        this.pageCount = 0;
                        this.allTickets = [];
                        this.myTickets = [];
                    }
        });
        this.setFocusToTextBox();
    }
    }

    onItemSelect(item: any, indexValue: any) {

        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                const selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id);
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {
                this.ticketTypesSort();
                if (type.value.trim().includes('FLP360')) {
                    type.subTypes.forEach((subType: any) => {
                        const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                    });
                } else {
                    type.subTypes.forEach((subType: any) => {
                    this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                    });
                }
                if (type.value === TicketType.Order) {
                    this.getDisputeReasons();
                    this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
                } else {
                    this.dropdownSettings.disputeReasonDropdownList=[];
                    this.dropdownSettings.disputeReasonSelectedItem=[];
                }
                });

                if (this.ticketTypes.length === this.dropdownSettings.typeSelectedItems.length) {
                          this.ticketTypeOnSelectAll = true;

                         } else {
                        this.ticketTypeOnSelectAll = false;
                   }

            }
        } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
                this.subTypeOnSelectAll = false;
                this.subTypesSort();
                if (this.dropdownSettings.subTypeDropdownList.length === this.dropdownSettings.subTypeSelectedItems.length) {
                this.subTypeOnSelectAll = true;
                this.subTypesSort();
                    }
        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
             if (this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length) {
                     this.statusOnSelectAll = true;
               }
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
                     if (this.sourceTypes.length === this.dropdownSettings.sourceSelectedItems.length) {
                     this.sourceOnSelectAll = true;
               }
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
                 this.departmentOnSelectAll = false;
                if (this.departments.length === this.dropdownSettings.departmentSelectedItems.length) {
                     this.departmentOnSelectAll = true;
                   }
                   if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                        const deptIds = this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id);
                        this.getAssignedUsersByDepartments(deptIds);
                   }else{
                    this.dropdownSettings.createdByDropdownList = [];
                    this.dropdownSettings.createdBySelectedItems = [];
                   }
          } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
                   if (this.ticketPriorities.length === this.dropdownSettings.prioritySelectedItems.length) {
                    this.priorityOnSelectAll = true;
                   }
           }else if (this.dropdownSettings.createdByIndex === +indexValue) {
                    this.createdByOnSelectAll = false;
                   if (this.users.length === this.dropdownSettings.createdBySelectedItems.length) {
                        this.createdByOnSelectAll = true;
                   }
           } 
           else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
                this.disputeReasonOnSelectAll = false;
             if (this.disputeReason.length === this.dropdownSettings.disputeReasonSelectedItem.length) { // need to change
                     this.disputeReasonOnSelectAll = true;
               }
        }


    }

    onItemDeSelect(item: any, indexValue: any) {
        if (this.dropdownSettings.subTypeIndex === +indexValue) {
            if (this.isDiputeTicketSearch && this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length === 0) {
               this.subTypesSort();
            }
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {

                const selectedIds: any[] = this.dropdownSettings.typeSelectedItems.map((index: any) => index.id);
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(item => selectedIds.some(index => index === item.id)).forEach(type => {
                this.subTypesSort();
                if (type.value.includes('FLP360')) {
                    type.subTypes.forEach((subType: any) => {
                        const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        this.ticketTypeOnSelectAll = false;
                        this.ticketTypesSort();
                    });
                } else {
                    type.subTypes.forEach((subType: any) => {
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                        this.ticketTypeOnSelectAll = false;
                        this.ticketTypesSort();
                    });
                }
                    if (type.value === TicketType.Order) {
                        this.getDisputeReasons();
                        this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
                        this.disputeReasonOnSelectAll = false;
                    } else {
                        this.dropdownSettings.disputeReasonDropdownList=[];
                        this.dropdownSettings.disputeReasonSelectedItem=[];
                        this.ticketTypeOnSelectAll = false;
                    }
                });

            } else if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length === 0 && this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter((item: any) => item.itemName.includes(TicketType.Order));
            } else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList=[];
                this.dropdownSettings.disputeReasonSelectedItem=[];
            }
        }

        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.showAllTickets) {
                this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
            } else if (this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length === 0) {
                this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList.filter((item: any) => item.id === Status.InProgress);
            }
        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;

        } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
        }
        else if(this.dropdownSettings.disputeReasonIndex === +indexValue){
             this.disputeReasonOnSelectAll=false;
        }
    }
    onSelectAll(items: any, indexValue: any) {

        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.ticketTypesSort();
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.dropdownSettings.disputeReasonDropdownList=[];
            this.dropdownSettings.disputeReasonSelectedItem=[];
            this.ticketTypes.forEach(type => {
                if (type.value.includes('FLP360')) {
                    type.subTypes.forEach((subType: any) => {
                        const subTypeName =  subType.name.trim() + '(' + type.value.trim() + ')';
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                    });
                } else {
                    type.subTypes.forEach((subType: any) => {
                        this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                    });
                }
                if (type.value === TicketType.Order) {
                    this.getDisputeReasons();
                    this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
                    this.disputeReasonOnSelectAll = true;
                }

            });
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = true;
            this.getAssignedUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map((item: any) => item.id));

        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = true;
        } else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = true;
            this.subTypesSort();
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = true;
        } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = true;
        } else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = true;
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
          this.disputeReasonOnSelectAll = true;
         }
    }
    onDeSelectAll(items: any, indexValue: any) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter((item: any) => item.itemName.includes(TicketType.Order));
                this.ticketTypesSort();
            } else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList=[];
                this.dropdownSettings.disputeReasonSelectedItem=[];
            }
        }
        if (this.dropdownSettings.subTypeIndex === +indexValue) {
            if (this.isDiputeTicketSearch && this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length === 0) {
                this.subTypeOnSelectAll = false;
                this.ticketTypesSort();
            }
        } else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
        } else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        } else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        } else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
        }
    }

    clearFields() {
        this.dropdownSettings.settings = {...this.dropdownSettings.settings, disabled: false};
        this.chRef.detectChanges();
        this.myTicketsForm.controls['overDueCount'].enable();
        this.myTicketsForm.reset();
        this.setFocusToTextBox();
        this.intializeMultiselectDropdowns();
        this.getTicketTypesAndSubTypes();
        this.getSourceTypes();
        this.getTicketStatus();
        this.showAllTickets = true;
        this.getTicketPriorities();
        const element = document.getElementById('ticketType');
        if (element) {
            element.focus();
        }
        this.myTicketsForm.get('operatingCountryId').setValue(this.countryId);
        this.ticketTypeOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.createdByOnSelectAll=true;
        this.disputeReasonOnSelectAll=true;

    }
    setFocusToTextBox() {
        setTimeout(function () {
            const element = <HTMLInputElement>document.getElementById('ticketType');
            const email = <HTMLInputElement>document.getElementById('email');
            if (element.value) { element.focus(); }
            else if (email.value) { email.focus(); }
            else { element.focus(); }

        }, 1000);
    }
    OnTabSearchFocus() {
        const element = document.getElementById('search-button');
        if (element) {
            element.focus();
        }
        event.preventDefault();
    }

    getOperatingCountries() {
        if (this.operatingCountries) {
            const countryInfo = this.operatingCountries.find((country: any) =>  country.id === this.countryId);
            if (countryInfo) {
                this.operatingCountries.splice( this.operatingCountries.indexOf(countryInfo), 1 );
                this.operatingCountries.splice(0, 0, countryInfo);
            }
        }
    }

    getAllowedCountries() {
        let countryIds: any = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',').map(i => +i);
                if(countryIds.includes(OperatingCountryEnums.USA)){
                    return OperatingCountryEnums.USA;
                }
                return countryIds[0];
            }
        }
        return OperatingCountryEnums.USA;
    }

    goToViewTicket(id: any, ticketNumber: any) {
        if (this.isTicketView) {
            const ticketTab = new TicketTabInfo();
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = 'View Ticket - ' + ticketNumber;
            ticketTab.viewTicket = true;
            ticketTab.isTeamTicket = false;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        } else {
            this.displayAlertbox();
        }
    }
    getDisputeReasons() {
        this.dropdownSettings.disputeReasonDropdownList =[];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this._customerservice.getDisputeReasons().subscribe(response => {
            if (response) {
                this.disputeReason= response;
                this.disputeReason.forEach(item => {
                    this.dropdownSettings.disputeReasonDropdownList.push({ id: item.id, itemName: item.value.trim() });                    
                });
                this.dropdownSettings.disputeReasonDropdownList.sort(function (item1, item2) {
                    const tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) { //sort string ascending
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
             //   this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
            }else{
                this.disputeReason = [];
                this.dropdownSettings.disputeReasonDropdownList = [];
              //  this.dropdownSettings.disputeReasonSelectedItem = [];
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/my-tickets.component.ts